import React from "react";
// import PropTypes from "prop-types";

import ConnectedPurposeSelect from "../../shared/containers/filters/connected_purpose";
import ConnectedCountriesSelect from "../../shared/containers/filters/connected_countries";
import ConnectedParametersPopover from "../../shared/containers/filters/connected_parameters";
import ShowOnlyMandatory from "../../shared/containers/filters/show_only_mandatory";
import ShowOnlyCurrent from "../../shared/containers/filters/show_only_current";
import MinMaxSelect from "../../shared/containers/filters/min_max";

class MainFilters extends React.Component {
  render () {
    const arrowStyle = {
      height: "100%",
      margin: "auto",
      color: "white",
      fontSize: "30px"
    };
    return (
      <div className="main-filters">
        <div className="row">
          <ConnectedPurposeSelect />
          <i className="fa fa-arrow-right" style={arrowStyle} />
          <ConnectedParametersPopover />
          <i className="fa fa-arrow-right" style={arrowStyle} />
          <ConnectedCountriesSelect />
        </div>
        <div className="row">
          <ShowOnlyMandatory />
          <ShowOnlyCurrent />
          <MinMaxSelect />
        </div>

      </div>
    );
  }
}

MainFilters.propTypes = {
  // searchIsBeingSaved: PropTypes.bool.isRequired,
};

export default MainFilters;
